export * from "expo-router";
// Shadow expo-router's `useGlobalSearchParams` (leaked by `export *` above) with a banned throwing
// shim. A local named export overrides a star re-export of the same name, so importers of this
// wrapper get the guarded version, never the real global-params hook. See its doc for why.
export { useGlobalSearchParams } from "./use-global-search-params.ts";
export type {
  Href,
  HrefObject,
  ImperativeRouter,
  ResolvedRouteParams,
  RoutePath,
} from "./types.ts";
export { dismissToSynchronously } from "./dismiss-to-synchronously.ts";
export { useScopedPathname } from "./use-scoped-pathname.ts";
export { useRouter } from "./router.ts";
export {
  useLayoutSearchParams,
  useLocalSearchParams,
  useLocalSearchParamsFromExpoRouter,
} from "./use-local-search-params.ts";
export {
  decodeRouteParamString,
  resolveGraphemeFromRouteSources,
  resolveRouteParam,
  resolveRouteParams,
} from "./route-params.ts";
